// extracted by mini-css-extract-plugin
export default {"home":"Signup_home__fHfSM","forms":"Signup_forms__Zu1Mw"};